import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/page/layout/layout'
import Index from '@/page/index/index'
/*const Layout = r => require.ensure([], () => r(require('../page/layout/layout')), 'Layout');
const Index = r => require.ensure([], () => r(require('../page/index/index')), 'Index');*/
const Contact = r => require.ensure([], () => r(require('../page/contact/contact')), 'Contact');	// 警民联系牌
const Express = r => require.ensure([], () => r(require('../page/express/express')), 'Express');	// 实名寄递
const Police = r => require.ensure([], () => r(require('../page/police/police')), 'Police');		// 社区民警
const Consult = r => require.ensure([], () => r(require('../page/consult/consult')), 'Consult');	// 转社区民警咨询工单
const Traffic = r => require.ensure([], () => r(require('../page/check_traffic/check_traffic')), 'Traffic');		// 交通设备举报审核
const Security = r => require.ensure([], () => r(require('../page/check_security/check_security')), 'Security');	// 治安举报审核
const News = r => require.ensure([], () => r(require('../page/news/news')), 'News');								// 新闻分类
const NewsList = r => require.ensure([], () => r(require('../page/news_list/news_list')), 'NewsList');				// 新闻列表
const NewsDetail = r => require.ensure([], () => r(require('../page/news_detail/new_detail')), 'NewsDetail');		// 新闻详情
const Clue = r => require.ensure([], () => r(require('../page/clue/clue')), 'Clue');								// 线索举报
const Map = r => require.ensure([], () => r(require('../page/map/map')), 'Map');
const Map2 = r => require.ensure([], () => r(require('../page/map2/map2')), 'Map2');	// 社区民警地图搜索
const Error = r => require.ensure([], () => r(require('../page/error/error')), 'Error');							// 错误提醒
const Success = r => require.ensure([], () => r(require('../page/success/success')), 'Success');					// 成功提醒
const TelDetail = r => require.ensure([], () => r(require('../page/tel_detail/tel_detail')), 'TelDetail');			// 警民联系牌详情页
const ViolationInquiry = r => require.ensure([], () => r(require('../page/violation_inquiry/violation_inquiry')), 'ViolationInquiry');		// 违章查询
const My = r => require.ensure([], () => r(require('../page/my/my')), 'My');																// 个人中心
const MyConsult = r => require.ensure([], () => r(require('../page/my_consult/my_consult')), 'MyConsult')									// 我的咨询
const Order = r => require.ensure([], () => r(require('../page/order/order')), 'Order')														// 我的订单
const OrderList = r => require.ensure([], () => r(require('../components/order_list/order_list')), 'OrderList')								// 订单列表
const ClueHistory = r => require.ensure([], () => r(require('../page/clue_history/clue_history')), 'ClueHistory')							// 我的线索
const SecurityHistory = r => require.ensure([], () => r(require('../components/security_history/security_history')), 'SecurityHistory')		// 治安线索
const TrafficHistory = r => require.ensure([], () => r(require('../components/traffic_history/traffic_history')), 'TrafficHistory')			// 交通线索
const ConsultHotline = r => require.ensure([], () => r(require('../components/consult_hotline/consult_hotline')), 'ConsultHotline')			// 热线咨询
const ConsultTransfer = r => require.ensure([], () => r(require('../components/consult_transfer/consult_transfer')), 'ConsultTransfer')		// 转接咨询
const MicroPolice = r => require.ensure([], () => r(require('../page/micro_police/micro_police')), 'MicroPolice')							// 微警务
const Adress = r => require.ensure([], () => r(require('../page/adress/index')), 'Adress')													// 地址管理
const AddAdress = r => require.ensure([], () => r(require('../page/add_adress/index')), 'AddAdress')										// 添加地址
const Id2 = r => require.ensure([], () => r(require('../page/id2/index')), 'Id2')															// 身份证业务
const Qrcode = r => require.ensure([], () => r(require('../page/qrcode/qrcode')), 'Qrcode')													// 我的二维码
const Share = r => require.ensure([], () => r(require('../page/share/share')), 'Share')														// 我的二维码
const VideoAlarm = r => require.ensure([], () => r(require('../page/video_alarm/index')), 'VideoAlarm')										// 视频报警
const Ems = r => require.ensure([], () => r(require('../page/ems/index')), 'Ems')										// EMS寄递
const CmccIndex = r => require.ensure([], () => r(require('../page/cmcc_index/cmcc_index')), 'CmccIndex')
const CmccForm = r => require.ensure([], () => r(require('../page/cmcc_form/cmcc_form')), 'CmccForm')
const Upgrade = r => require.ensure([], () => r(require('../page/upgrade/index')), 'Upgrade')
const Housecard = r => require.ensure([], () => r(require('../page/housecard/housecard')), 'Housecard')
const GaFwpt = r => require.ensure([], () => r(require('../page/ga_fwpt/ga_fwpt')), 'GaFwpt')

Vue.use(Router)

export default new Router({
	routes: [
		{
			path: '/order',
			name: 'order',
			component: Order,
			children: [{
				path: 'list/:id',
				component: OrderList,
				name: 'order_list'
			}],
			meta: {
				policeAuth: true
			}
		},
		{
			path: '/my_consult',
			name: 'MyConsult',
			component: MyConsult,
			children: [{
				path: 'consult_hotline',
				component: ConsultHotline,
				name: 'consult_hotline'
			}, {
				path: 'consult_transfer',
				component: ConsultTransfer,
				name: 'consult_transfer'
			},{
				path: '',
				redirect: '/my_consult/consult_hotline'
			}]
		}, {
			path: '/clue_history',
			name: 'clue_history',
			component: ClueHistory,
			children: [{
				path: 'security_history',
				component: SecurityHistory,
				name: 'security_history',
			},
			{
				path: 'traffic_history',
				component: TrafficHistory,
				name: 'traffic_history',
			},
			{
				path: '',
				redirect: '/clue_history/security_history'
			}]
		},
		{
			path: '/my',
			name: 'my',
			component: My,
			meta: {
				index: '96111',
				wechatAuth: true
			}
		},
		{
			path: '/qrcode',
			name: 'qrcode',
			component: Qrcode,
			meta: {
				policeAuth: true
			}
		},
		{
			path: '/share/:id',
			name: 'share',
			component: Share
		},
		{
			path: '/addadress',
			name: 'addadress',
			component: AddAdress
		},
		{
			path: '/id2',
			name: 'id2',
			component: Id2
		},
		{
			path: '/video_alarm',
			name: 'video_alarm',
			component: VideoAlarm
		},
		{
			path: '/ems',
			name: 'ems',
			component: Ems
		},
		{
			path: '/cmcc/index',
			name: 'cmcc_index',
			component: CmccIndex,
			meta: {
				policeAuth: true
			}
		},
		{
			path: '/cmcc/form',
			name: 'cmcc_form',
			component: CmccForm
		},
		{
			path: '/adress',
			name: 'adress',
			component: Adress
		},
		{
			path: '/violation_inquiry',
			name: 'violation_inquiry',
			component: ViolationInquiry,
			meta: {
				policeAuth: true
			}
		},
		{
			path: '/contact',
			name: 'contact',
			component: Contact
		}, {
			path: '/express',
			name: 'express',
			component: Express,
			meta: {
				policeAuth: true
			}
		}, {
			path: '/police',
			name: 'police',
			component: Police,
			meta: {
				policeAuth: true
			}
		}, {
			path: '/micro_police',
			name: 'micro_police',
			component: MicroPolice,
			meta: {
				policeAuth: true
			}
		}, {
			path: '/consult',
			name: 'consult',
			component: Consult,
		}, {
			path: '/check/traffic',
			name: 'traffic',
			component: Traffic
		}, {
			path: '/check/security',
			name: 'security',
			component: Security
		}, {
			path: '/news/detail/:id',
			name: 'news_detail',
			component: NewsDetail
		}, {
			path: '/clue',
			name: 'clue',
			component: Clue,
			meta: {
				policeAuth: true
			}
		}, {
			path: '/map',
			name: 'map',
			component: Map
		}, {
			path: '/map2',
			name: 'map2',
			component: Map2
		},{
			path: '/tel_detail',
			name: 'tel_detail',
			component: TelDetail,
			meta: {
				index: '96111'
			}
		}, {
			path: '/error/:message',
			name: 'error',
			component: Error,
			props: true
		}, {
			path: '/success',
			name: 'success',
			component: Success
		},
		{
			path: '/upgrade',
			name: 'upgrade',
			component: Upgrade
		}, {
			path: '/:token?',
			name: 'layout',
			component: Layout,
			children: [{
				path: '',
				component: Index,
				name: 'index',
				meta: {
					index: '96111'
				}
			}, {
				path: '/news',
				component: News,
				name: 'news',
				children: [{
					path: 'list/:id',
					component: NewsList,
					name: 'news_list',
					meta: {
						index: '96111'
					}
				}]
			}]
		},
        {
            path: '/housecard',
            name: 'housecard',
            component: Housecard,
        },
        {
			path: '/ga_fwpt',
			name: 'ga_fwpt',
			component: GaFwpt
		}
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js